import Cards from "ab-cards";
import { useTranslation } from "next-i18next";
const RegaleExperiencia = ({ classname, moduloCross, i18n }) => {
  let disfrute = moduloCross?.modCrossRegaleExperiencia;
  const { t } = useTranslation("common", { i18n });

  return (
    <Cards
      className={classname}
      title={
        i18n.language == "en"
          ? disfrute?.titleregaleen || disfrute?.titleregale
          : i18n.language == "de"
            ? disfrute?.titleregalede || disfrute?.titleregale
            : disfrute?.titleregale
      }
      cards={disfrute?.cardsregale}
      text={disfrute?.textregale}
      animated={disfrute?.animatedregale}
      link={
        classname == "hide-ver-todos"
          ? null
          : {
            text: t("ver-todas-experiencias"),
            href: t("/tienda/bono-regalo-experience-box/"),
          }
      }
      linkBefore={true}
      i18n={i18n}
    />
  );
};

export default RegaleExperiencia;
